export default {"src":"/_next/static/media/saveSearch.639c395f.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};